<template>
  <a-card nopad class="indigo lighten-3">
    <v-row justify="space-between" class="booking-title grey darken-1 white--text">
      <router-link :to="link" class="daylink">
        <span class="caption">{{ dayTitle.day }}:</span>
        <span class="mx-2 subtitle-2">{{ dayTitle.date }}</span>
      </router-link>

      <v-tooltip left v-if="!showCancelled && hiddenCount">
        <template v-slot:activator="{ on }">
          <div v-on="on" style="display: flex; align-items: center">
            <v-btn x-small icon text color="black" style="pointer-events: none">
              <v-icon small>cancel</v-icon>
            </v-btn>
            <span class="mx-1 black--text">{{ hiddenCount }}</span>
          </div>
        </template>

        <span>{{ hiddenCount }} Cancelled Suppliers (Hidden)</span>
      </v-tooltip>
    </v-row>
    <DayInfoDaySection
      v-for="(config, index) in dayConfig"
      :key="index"
      :dayNum="dayNum"
      :config="config"
      :date="dayData.date"
      :dayData="dayData[config.dbkey]"
      :showCancelled="showCancelled"
      @altstatus="(v) => $emit('altstatus', v)"
      @editRoomName="(v) => $emit('editRoomName', v)"
      @editConfirm="(v) => $emit('editConfirm', v)"
    />
  </a-card>
</template>

<script>
import DayInfoDaySection from "./_DayInfoDaySection";
import SUPMENU from "@/config/menus/suppliersMenu";

export default {
  props: {
    dayNum: Number,
    dayCount: Number,
    showCancelled: Boolean,
  },
  components: {
    DayInfoDaySection,
  },
  data() {
    const vm = this;
    return {
      dayConfig: SUPMENU.FULL.map((item) => {
        return {
          type: item.module,
          title: item.title,
          dbkey: item.alt,
          icon: item.icon,
        };
      }).filter((item) => {
        if (vm.dayNum === vm.dayCount - 1) {
          return !["ALL", "HOTEL"].includes(item.type);
        }
        return item.type !== "ALL";
      }),
    };
  },
  computed: {
    dayTitle() {
      return this.$store.getters["BookingDayStore/day_name"](this.dayNum);
    },
    dayData() {
      return this.$store.getters["BookingDayStore/day"](this.dayNum);
    },
    link() {
      return {
        name: "booking_day",
        params: {
          booking_id: this.$store.getters["BookingStore/booking_id"],
          day: this.dayNum + 1,
        },
      };
    },

    hiddenCount() {
      let supidlist = [];
      let temp = this.$store.getters["BookingDayStore/suppliers"];

      SUPMENU.FULL.forEach((v) => {
        if (v.module === "ALL") return;
        supidlist.push(...this.dayData[v.alt]);
      });

      return supidlist.filter((item) => temp[item]?.status === -1).length;
    },
  },
  methods: {
    hasData(data) {
      return data ? data.length > 0 : false;
    },
  },
};
</script>

<style lang="scss">
.daylink {
  text-decoration: none;

  span {
    color: white;
  }

  &:hover {
    opacity: 0.6;
  }
}
</style>
